'use client'

import { Instrument } from '@lyra/web/constants/instruments'
import { MarketId } from '@lyra/web/constants/markets'
import TradeFormOrderbookModalQueryParams from '@lyra/web/containers/trade/TradeFormOrderbookModalQueryParams'
import useSelectedInstruments from '@lyra/web/hooks/useSelectedInstruments'

import OptionsChainSection from '../../../containers/trade/OptionsChainSection'

type Props = {
  marketId: MarketId
  instruments: Instrument[]
}

export default function OptionsPageHelperMobile({ marketId, instruments }: Props) {
  const { selectedInstruments, removeAllInstruments } = useSelectedInstruments()

  const selectedInstrument = selectedInstruments.length ? selectedInstruments[0] : null

  return (
    <>
      <OptionsChainSection
        flexGrow={1}
        flexShrink={1}
        marketId={marketId}
        instruments={instruments}
      />
      {selectedInstrument ? (
        <TradeFormOrderbookModalQueryParams
          instrumentName={selectedInstrument.instrument_name}
          onClose={removeAllInstruments}
          onSubmitOrder={removeAllInstruments}
        />
      ) : null}
    </>
  )
}
